export const currentUtcMonth = (date = new Date()) => {
  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  return `${year}-${month}`
}

/**
 * Normalizes a registration date to the UTC `YYYYMMDD` integer string the backend
 * Unleash context uses (see stpancras-general-api unleash-source.js
 * normalizeRegisteredAt), so the `pricing.feature_set` `registeredAt NUM_GTE`
 * constraint is evaluated identically on client and server.
 */
export const normalizeRegisteredAt = (value) => {
  let date = value ? new Date(value) : new Date()
  if (Number.isNaN(date.getTime())) date = new Date()
  const yyyymmdd = date.getUTCFullYear() * 10000
    + (date.getUTCMonth() + 1) * 100
    + date.getUTCDate()
  return String(yyyymmdd)
}

/**
 * Mirrors VoteCountSlidePlugin.voteCountTopic / QuizLiveCountsSubscriber.bucketTopic:
 * the counting KV namespace is rooted under the live-stats version prefix
 * (e.g. ST2), which general-api also prepends via AHA_SYNC_TOPIC_PREFIX. A
 * key built without it lands under the wrong root and always reads empty.
 */
export const buildMonthlyCountKey = (versionPrefix, livestatsPrefix, ownerId, month) => {
  const versionSegment = versionPrefix ? `/${versionPrefix}` : ''
  return `${versionSegment}/${livestatsPrefix}/counting/PARTICIPANT_COUNT/PER_PRESENTER/PER_MONTH/${ownerId}/${month}/count`
}
